import { Injectable } from '@angular/core'
import {
  CanActivate,
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree
} from '@angular/router'
import { Observable, map, take } from 'rxjs'
import { ContextService } from '@services/context.service'
import { UserRole } from '@app/domain/AccountUser'

@Injectable({
  providedIn: 'root'
})
export class UserRoleGuard implements CanActivate, CanLoad {
  
  constructor(
    private contextService: ContextService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUserAccess(route);
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUserAccess(route);
  }

  private checkUserAccess(route: Route | ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const requiredRole = route.data?.['requiredRole'] as UserRole | undefined;
    return this.contextService.user$.pipe(
      take(1),
      map(user => {
        if (requiredRole === undefined) {
          return true
        }
        if (!user) {
            return false
        }
        const userRole = user.role
        const roleHierarchy = [
            UserRole.STAFF,
            UserRole.MANAGER, 
            UserRole.OWNER,
        ]
        const userRoleIndex = roleHierarchy.indexOf(userRole);
        const requiredRoleIndex = roleHierarchy.indexOf(requiredRole);
        if (userRoleIndex >= requiredRoleIndex) {
          return true
        }
        return this.router.createUrlTree(['/'])
      })
    );
  }
}
